module.exports = __webpack_public_path__ + "img/Willy.7487646a.jpg";